import type { ShippingMethodLegacy } from '@stickerapp-org/checkout-sdk';
import { getCheckoutSdk } from '$lib/checkout.svelte';

const cheapestShippingMethodReducer = (
  result: ShippingMethodLegacy | undefined,
  shippingMethod: ShippingMethodLegacy,
): ShippingMethodLegacy => {
  if (!result || result.price.total.major > shippingMethod.price.total.major) {
    return shippingMethod;
  }

  return result;
};

const preloadShippingMethod = async (): Promise<void> => {
  const sdk = getCheckoutSdk();

  if (!sdk) {
    return;
  }

  const shipping = sdk.state.checkout?.shipping;

  if (shipping?.$type !== 'checkoutPage' || !!shipping.selectedShippingMethod) {
    return;
  }

  const cheapestShippingMethod = shipping.shippingMethods.reduce(
    cheapestShippingMethodReducer,
    undefined,
  );

  if (!cheapestShippingMethod) {
    return;
  }

  try {
    await sdk.actions.selectShippingMethod(cheapestShippingMethod.id);
  } catch {
    // TODO: Maybe this should be tracked?
  }
};

const preloadPaymentMethod = async (): Promise<void> => {
  const sdk = getCheckoutSdk();

  if (!sdk) {
    return;
  }

  const payment = sdk.state.checkout?.payment;

  if (payment?.$type !== 'checkoutPage' || !!payment.selectedPaymentMethod) {
    return;
  }

  const paymentMethod = payment.paymentMethods.at(0);

  if (!paymentMethod) {
    return;
  }

  try {
    await sdk.actions.selectPaymentMethod(paymentMethod.id);
  } catch {
    // TODO: Maybe this should be tracked?
  }
};

export const loadCheckoutWithDefaults = async () => {
  const sdk = getCheckoutSdk();

  if (!sdk) {
    return;
  }

  await sdk.actions.loadCheckout().then(preloadShippingMethod).then(preloadPaymentMethod);
};
